/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Joi from 'joi-browser';

import { withStyles } from '@material-ui/core/styles';

import Form from '../../../../common/Form';
import ErrorInline from '../../../../common/ErrorMessages/ErrorInline';
import { form as FormStyle } from '../../../../style/form';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import configEnv from '../../../../config';

const { PERSIST_KEY } = configEnv;

const styles = ({ typography, palette }) => FormStyle(typography, palette);

class EnterItemNumber extends Form {
    state = {
        data: { itemnumber: '' },
        errors: {},
        inlineError: '',
    };

    schema = {
        itemnumber: Joi.string()
            .trim()
            .max(20)
            .required()
            .label('Item Number'),
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const { errors } = this.state;
        const { error: errorResponse } = props;
        // Reset password fields
        if (errorResponse && errorResponse.errorMessage && errorResponse.type === 'field' && errorResponse.name) {
            errors[errorResponse.name] = errorResponse.errorMessage;
            this.setState({ errors });
        } else if (errorResponse && errorResponse.errorMessage === '') {
            this.setState({ errors: {} });
        }
    };

    /* eslint no-underscore-dangle: ["error", { "allow": ["__target__"] }] */
    doSubmit = (submitData, __target__ = '') => {
        const {
            data: { itemnumber },
        } = this.state;
        const { recipient } = submitData;

        const sku = itemnumber || (__target__ && __target__.itemnumber);

        if (sku) {
            submitData.handleGiftListAddToCart(
                sku.toUpperCase(),
                recipient,
                true,
            );
        } else {
            // console.error('Product id not found.');
            this.setState({
                inlineError:
                    'Product not found. Please enter a corect product number.',
            });
        }
    };

    doChange = () => {
        this.setState({ inlineError: '' });
    };

    render() {
        const { classes } = this.props;
        const { isReadyState, recipient, handleGiftListAddToCart } = this.props;
        const submitData = { recipient, handleGiftListAddToCart };
        return (
            <>
                <p>
                    Ener an item number from the catalog or website to add it
                    for your recipient.
                </p>
                <p>
                    For best results, enter numbers like this: 4151X (instead of
                    this: G4151X or G-4151X).
                </p>

                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    className={classes.form}
                    disabled={!isReadyState}
                >
                    <ErrorInline
                        error={recipient.error}
                        isReadyState={isReadyState}
                    />
                    <h2 className="no-margin-bottom margin-top-2x">
                        Enter Item Number
                    </h2>
                    {this.renderInput({
                        name: 'itemnumber',
                        label: null,
                        type: 'text',
                        pattern: '^[0-9a-zA-Z\\-]*$',
                        length: 20,
                        placeholder: '#####',
                        desktop: false,
                    })}

                    <div className="margin-top">
                        {this.renderButton({
                            label: `Add For ${recipient.firstname} ${recipient.lastname}`,
                            className: 'submit-btn buttonHD',
                            onClick: null,
                            type: 'submit',
                            waitingLabel: !isReadyState ? 'Adding To Cart...' : '',
                        })}
                    </div>
                </form>
            </>
        );
    }
}

EnterItemNumber.defaultProps = {
    isReadyState: true,
};

EnterItemNumber.propTypes = {
    classes: PropTypes.object.isRequired,
    isReadyState: PropTypes.bool,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        recipient: newState.giftList.recipient,
        isReadyState: newState.isReadyState,
        error: newState.giftList.error,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListAddToCart: (productId, recipient, closeModal) => dispatch(EventDispatcher.handleGiftListAddToCart(
        productId,
        recipient,
        closeModal,
        'mobile',
    )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(EnterItemNumber));
